module.exports = __webpack_public_path__ + "static/img/hand.d2843b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/hand.png
// module id = fFrE
// module chunks = 1